import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { dealLockHooks } from '../../hooks';
import { createBrowseTemplatesEvent } from '../analytics/cdlEventCreators';

export const useManualTemplatesList = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const isDisabled = dealLockHooks.useIsDealLocked();

    const open = () => {
        setIsOpen(true);
        dispatch(createBrowseTemplatesEvent());
    };

    const close = () => setIsOpen(false);

    return { isOpen, isDisabled, open, close };
};
